import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Result, Button } from 'antd';

class NoPage extends Component {
	render() {
		const { history } = this.props;
		history.replace('/')
		return (
			<Result
				status="404"
				title="404"
				subTitle="Sorry, the page you visited does not exist."
				extra={
					<Button
						type="primary"
						onClick={() => {
							history.goBack();
						}}
					>
						Back Home
					</Button>
				}
			/>
		);
	}
}

export default withRouter(NoPage);
